import { useMemo, useState } from 'react';

import type { SlabStep } from './SlabStepper';

type SlabSteps<StepsType extends string> = SlabStep<StepsType>[];

interface UseStepperProps<StepsType extends string> {
  initialStep: StepsType;
  steps: SlabSteps<StepsType>;
}

interface ReturnStepperProps<StepsType extends string> {
  steps: SlabSteps<StepsType>;
  activeStep: StepsType;
  changeStep(step: StepsType): void;
}

export const useStepper = <StepsType extends string>({
  initialStep,
  steps,
}: UseStepperProps<StepsType>): ReturnStepperProps<StepsType> => {
  const [activeStep, setStep] = useState<StepsType>(initialStep);

  const visibleSteps = useMemo(() => steps.filter(({ hidden = false }) => !hidden), [steps]);

  const changeStep = (newStep: StepsType): void => setStep(newStep);

  return {
    steps: visibleSteps,
    activeStep,
    changeStep,
  };
};
